import { createSlotsContext } from "@grandvisionhq/slots";
const [WhatStepSlotsProvider, useWhatStepSlots] = createSlotsContext({
  displayName: "WhatStepSlotsContext"
});
export {
  WhatStepSlotsProvider,
  useWhatStepSlots
};
//# sourceMappingURL=WhatStepSlotContext.js.map
